export const setCurrentHeaderHeight = (currentHeaderHeight) => ({
  type: "DOM/CURRENT_HEADER_HEIGHT_UPDATED",
  payload: {
    currentHeaderHeight
  }
});
